import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';

// Zone.js is intentionally NOT imported: this app runs zoneless change detection
// (provideZonelessChangeDetection in appConfig, Feature #31662). CD is driven by
// signals, AsyncPipe, template events and explicit markForCheck() rather than
// zone.js. Do not re-add 'zone.js' here or to project.json polyfills.
import {
  environment,
  suppressNonErrorConsoleInProduction,
} from '@ups/xplat/core';
import { isInMsalSilentIframe } from '@ups/xplat/web/utils';

suppressNonErrorConsoleInProduction(environment.production);

// Do NOT bootstrap inside MSAL's hidden silent-renewal iframe (#31904): booting
// the SPA there makes in-iframe API calls that 401 and re-trigger auth, which
// makes MSAL throw block_iframe_reload and strands an expiring Entra session.
if (!isInMsalSilentIframe()) {
  // Standalone bootstrap (WI 31715): appConfig is the whole provider list.
  bootstrapApplication(App, appConfig).catch((err) =>
    console.error('main.ts::bootstrapApplication()', err)
  );
}
